export const GET_BIKE_BRANDS_REQUEST = 'GET_BIKE_BRANDS_REQUEST';
export const GET_BIKE_BRANDS_SUCCESS = 'GET_BIKE_BRANDS_SUCCESS';
export const GET_BIKE_BRANDS_FAILURE = 'GET_BIKE_BRANDS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/get_bike_brands.constants.js